import {
    usePostPaymentInformationMutation,
    useGetSavedCardQuery,
    usePostApplyCouponMutation,
    useSubmitPaymentMutation,
    useGetRecentOrdersQuery,
    useGetReviewQuery
} from '@/rtkQuery/features/services/checkout/checkoutApi.slice';

export const useCheckoutService = () => {
    const [
        triggerPostPayment,
        {
            data: paymentData,
            error: paymentError,
            isLoading: paymentLoading,
            isSuccess: paymentSuccess,
            isError: paymentIsError,
            status: paymentStatus,
        },
    ] = usePostPaymentInformationMutation();

    const {
        data: savedCardData,
        error: savedCardError,
        isLoading: savedCardLoading,
        isSuccess: savedCardSuccess,
        isError: savedCardIsError,
        refetch: refetchSavedCard,
        status: savedCardStatus,
    } = useGetSavedCardQuery();

    const paymentErrorMessage =
        (paymentError as any)?.message ||
        (paymentError as any)?.meta?.error ||
        'Something went wrong while submitting payment information';

    const savedCardErrorMessage =
        (savedCardError as any)?.meta?.error ||
        (savedCardError as any)?.message ||
        'Something went wrong while fetching saved card information';

    const [
        triggerApplyCoupon,
        {
            data: couponData,
            error: couponError,
            isLoading: couponLoading,
            isSuccess: couponSuccess,
            isError: couponIsError,
            status: couponStatus,
        },
    ] = usePostApplyCouponMutation();

    const couponErrorMessage =
        (couponError as any)?.meta?.error ||
        (couponError as any)?.message ||
        'Something went wrong while applying the coupon';


    const [
        triggerSubmitPayment,
        {
            data: submitPaymentData,
            error: submitPaymentError,
            isLoading: submitPaymentLoading,
            isSuccess: submitPaymentSuccess,
            isError: submitPaymentIsError,
            status: submitPaymentStatus,
        },
    ] = useSubmitPaymentMutation();

    const submitPaymentErrorMessage =
        (submitPaymentError as any)?.meta?.error ||
        (submitPaymentError as any)?.message ||
        'Something went wrong while submitting payment';

    const {
        data: recentOrders,
        error: recentOrdersError,
        isLoading: recentOrdersLoading,
        isSuccess: recentOrdersSuccess,
        isError: recentOrdersIsError,
        refetch: refetchRecentOrders,
        status: recentOrdersStatus,
    } = useGetRecentOrdersQuery();

    const recentOrdersErrorMessage =
        (recentOrdersError as any)?.meta?.error ||
        (recentOrdersError as any)?.message ||
        'Something went wrong while fetching recent orders';

    const {
        data: checkoutReviewData,
        error: checkoutReviewError,
        isLoading: checkoutReviewLoading,
        isSuccess: checkoutReviewSuccess,
        isError: checkoutReviewIsError,
        refetch: refetchCheckoutReview,
        status: checkoutReviewStatus,
    } = useGetReviewQuery();

    const checkoutReviewErrorMessage =
        (checkoutReviewError as any)?.meta?.error ||
        (checkoutReviewError as any)?.message ||
        'Something went wrong while fetching checkout review';



    return {
        submitPaymentInformation: triggerPostPayment,
        paymentData,
        paymentError,
        paymentLoading,
        paymentSuccess,
        paymentIsError,
        paymentStatus,
        paymentErrorMessage,

        savedCardData,
        savedCardError,
        savedCardLoading,
        savedCardSuccess,
        savedCardIsError,
        savedCardStatus,
        savedCardErrorMessage,
        refetchSavedCard,

        applyCoupon: triggerApplyCoupon,
        couponData,
        couponError,
        couponLoading,
        couponSuccess,
        couponIsError,
        couponStatus,
        couponErrorMessage,

        submitPayment: triggerSubmitPayment,
        submitPaymentData,
        submitPaymentError,
        submitPaymentLoading,
        submitPaymentSuccess,
        submitPaymentIsError,
        submitPaymentStatus,
        submitPaymentErrorMessage,


        recentOrders,
        recentOrdersError,
        recentOrdersLoading,
        recentOrdersSuccess,
        recentOrdersIsError,
        recentOrdersStatus,
        recentOrdersErrorMessage,
        refetchRecentOrders,

        checkoutReviewData,
        checkoutReviewError,
        checkoutReviewLoading,
        checkoutReviewSuccess,
        checkoutReviewIsError,
        checkoutReviewStatus,
        checkoutReviewErrorMessage,
        refetchCheckoutReview,

    };
};
